import { render, staticRenderFns } from "./WorkflowRunSuccess.vue?vue&type=template&id=512b0fce"
import script from "./WorkflowRunSuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowRunSuccess.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports